import React from "react";
import PropTypes from "prop-types";

import NextButton from "./NextButton";
import { currentQuestion } from "../../state/questionStates";

class ButtonContainer extends React.Component {
    render() {
        let current = currentQuestion(this.context.store.getState());
        if (current && "questionType" in current && current.questionType === "complete") {
            return null;
        }
        return (
            <div className="w3-padding-small w3-center">
                <NextButton/>
            </div>
        );
    }
}

ButtonContainer.contextTypes = {
    store: PropTypes.object
};

export default ButtonContainer;
